




import { defineComponent } from "@vue/composition-api";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import ToastUiViewer from "@/components/ToastUiViewer";

export default defineComponent({
  name: "WysiwygViewer",
  components: {
    ToastUiViewer,
  },
  props: { value: { type: String, default: "" } },
});
